import React from "react";
import Slider from "react-slick";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import event01 from "../../../assets/images/event_gallery/event_01.webp";
import event02 from "../../../assets/images/event_gallery/event_02.webp";
import event03 from "../../../assets/images/event_gallery/event_03.webp";
import event04 from "../../../assets/images/event_gallery/event_04.webp";
import event05 from "../../../assets/images/event_gallery/event_05.webp";
import event06 from "../../../assets/images/event_gallery/event_06.webp";
import event07 from "../../../assets/images/event_gallery/event_07.webp";
import event08 from "../../../assets/images/event_gallery/event_08.webp";
import event09 from "../../../assets/images/event_gallery/event_09.webp";
import event10 from "../../../assets/images/event_gallery/event_10.webp";
import event11 from "../../../assets/images/event_gallery/event_11.webp";
import event12 from "../../../assets/images/event_gallery/event_12.webp";
import event13 from "../../../assets/images/event_gallery/event_13.webp";

const eventImages = [
  event01,
  event02,
  event03,
  event04,
  event05,
  event06,
  event07,
  event08,
  event09,
  event10,
  event11,
  event12,
  event13,
];

function GalleryArrow({ onClick, direction }) {
  const Icon = direction === "prev" ? FaAngleLeft : FaAngleRight;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={direction === "prev" ? "Previous photo" : "Next photo"}
      className={`absolute top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white/90 text-primary shadow-card flex items-center justify-center hover:bg-primary hover:text-white transition-colors ${
        direction === "prev" ? "left-2 md:left-6" : "right-2 md:right-6"
      }`}
    >
      <Icon className="text-2xl" />
    </button>
  );
}

export default function EventGallery() {
  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    speed: 700,
    centerMode: true,
    centerPadding: "18%",
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <GalleryArrow direction="prev" />,
    nextArrow: <GalleryArrow direction="next" />,
    responsive: [
      { breakpoint: 1024, settings: { centerPadding: "10%" } },
      { breakpoint: 640, settings: { centerPadding: "24px" } },
    ],
  };

  return (
    <section className="event-gallery bg-gradient-to-b from-white via-[#eef6f1] to-white py-16 mb-4">
      <div className="text-center px-8 pb-10">
        <p className="text-primary font-semibold uppercase tracking-[0.2em] text-sm pb-2">
          Moments that matter
        </p>
        <h2 className="text-3xl md:text-4xl font-bold">Event Highlights</h2>
        <div className="w-20 h-1 bg-primary rounded-full mx-auto mt-4"></div>
      </div>
      <div className="relative max-w-[1600px] mx-auto">
        <Slider {...settings}>
          {eventImages.map((image, index) => (
            <div key={index} className="px-2 md:px-3">
              <div className="event-gallery-slide overflow-hidden rounded-2xl shadow-card">
                <img
                  src={image}
                  loading="lazy"
                  className="w-full aspect-[3/2] object-cover"
                  alt={`NAB Bangladesh event ${index + 1}`}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
